module.exports = __webpack_public_path__ + "img/zhhb-3.5aff4c77.png";